import { UsersState } from 'src/modules/users/types/UsersState';
import { RootState } from 'src/types/RootState';

export function getUsersState(state: RootState): UsersState {
  return state.users;
}
